<!-- Desktop Sidebar -->
<p-sidebar
  [visible]="true"
  [position]="isRtl ? 'right' : 'left'"
  [attr.dir]="isRtl ? 'rtl' : 'ltr'"
  [modal]="false"
  [dismissible]="false"
  [showCloseIcon]="false"
  [style]="{ width: sidebarCollapsed ? '80px' : '260px' }"
  class="custom-sidebar fixed-sidebar"
  [ngClass]="{ collapsed: sidebarCollapsed, rtl: isRtl }"
>
  <!-- Header -->
  <div
    class="sidebar-header"
    [ngClass]="!sidebarCollapsed ? '' : 'justify-content-center'"
    [attr.dir]="isRtl ? 'rtl' : 'ltr'"
  >
    <h2 class="logo" *ngIf="!sidebarCollapsed">Tal</h2>
    <button
      class="collapse-btn"
      (click)="collapseSide()"
      [attr.aria-label]="'MENU.COLLAPSE_SIDEBAR' | translate"
      type="button"
    >
      <i
        class="bi"
        [ngClass]="{
          'bi-chevron-double-right':
            (!isRtl && sidebarCollapsed) || (isRtl && !sidebarCollapsed),
          'bi-chevron-double-left':
            (!isRtl && !sidebarCollapsed) || (isRtl && sidebarCollapsed),
        }"
      >
      </i>
    </button>
  </div>

  <div
    class="sidebar-user-role"
    *ngIf="userRolesDisplay()"
    [class.collapsed-only]="sidebarCollapsed"
    [attr.title]="sidebarCollapsed ? userRolesDisplay() : null"
    [attr.dir]="isRtl ? 'rtl' : 'ltr'"
  >
    <i class="bi bi-person-badge" aria-hidden="true"></i>
    <div *ngIf="!sidebarCollapsed" class="sidebar-user-role-text">
      <span class="sidebar-user-role-label">{{ 'MENU.USER_ROLE' | translate }}</span>
      <span class="sidebar-user-role-value">{{ userRolesDisplay() }}</span>
    </div>
  </div>

  <!-- Menu -->
  <ul class="menu" [attr.dir]="isRtl ? 'rtl' : 'ltr'">
    <ng-container *ngFor="let item of menuItems">
      <li>
        <!-- عنصر بدون children -->
        <a
          *ngIf="!item.children?.length"
          [routerLink]="[item.route]"
          routerLinkActive="active"
        >
          <i [class]="item.icon || 'bi bi-folder'"></i>
          <span *ngIf="!sidebarCollapsed">{{ item.title }}</span>
        </a>

        <!-- عنصر مع children -->
        <div *ngIf="item.children?.length">
          <span class="menu-parent" (click)="toggleExpand(item)">
            <i [class]="item.icon || 'bi bi-folder'"></i>
            <span *ngIf="!sidebarCollapsed">{{ item.title }}</span>
            <i
              class="bi chevron"
              *ngIf="!sidebarCollapsed"
              [ngClass]="{
                'bi-chevron-down': item.expanded,
                'bi-chevron-right': !item.expanded && !isRtl,
                'bi-chevron-left': !item.expanded && isRtl,
              }"
            >
            </i>
          </span>
          <ul class="submenu" *ngIf="item.expanded && !sidebarCollapsed" [attr.dir]="isRtl ? 'rtl' : 'ltr'">
            <li *ngFor="let child of item.children">
              <a [routerLink]="[child.route]" routerLinkActive="active">
                <i [class]="child.icon || 'bi bi-file-text'"></i>
                <span>{{ child.title }}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
    </ng-container>
  </ul>

  <!-- Version -->
  <div class="sidebar-version">{{ 'MENU.VERSION' | translate }} 1.0.8.2</div>
</p-sidebar>
